import { Box, Grid, GridItem, VStack, HStack, Image, Button, Icon } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowRightStartOnRectangleIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline';
import { useAuth } from '@/lib/hooks/use-auth';
import { useScrollState } from '@/lib/hooks/use-scroll-state';

export default function LimitedNavigation() {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const isScroll = useScrollState();

  const handleLogout = () => {
    logout();
    navigate('/auth/login');
  };

  return (
    <Grid
      templateColumns={'auto 1fr auto'}
      px={{ base: 2, md: 4 }}
      py={2}
      position={'sticky'}
      top={0}
      left={0}
      right={0}
      zIndex={11}
      w={'full'}
      backdropFilter={'saturate(180%) blur(5px)'}
      boxShadow={isScroll ? 'sm' : ''}
      transition={'box-shadow 0.2s ease 0s'}
    >
      <GridItem gridRow={1} gridColumn={1} display={'flex'}>
        <VStack display={'block'} alignItems={'center'} justifyContent={'space-between'} gap={4}>
          <HStack gap={0} align={'center'}>
            <Box display={{ base: 'none', xl: 'block' }}>
              <Image src='/logo_horizontal.png' alt='Coach Hub' height={7} />
            </Box>
            <Box display={{ base: 'block', xl: 'none' }}>
              <Image src='/logo.png' alt='Coach Hub' height={7} />
            </Box>
            <Button
              size={'sm'}
              variant={'ghost'}
              onClick={() => {
                navigate(`/limited/${workspaceId}/workspaces`);
              }}
            >
              <Icon as={ArrowsRightLeftIcon} />
              Switch Team
            </Button>
          </HStack>
        </VStack>
      </GridItem>
      <GridItem gridRow={1} gridColumn={3}>
        <Button size={'sm'} variant={'ghost'} onClick={() => handleLogout()}>
          <Icon as={ArrowRightStartOnRectangleIcon} w={4} h={4} />
          Sign Out
        </Button>
      </GridItem>
    </Grid>
  );
}
